import { t } from 'i18next';
import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';
import { isCnpj, isEmail, isFilled, isPhone } from 'utils/old-ui-commons/validations';

export const CNPJ_MASK = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

const validatorForm = (values, phoneOptions) => {
  const errors = {};

  const validatePhone = (phoneNumber) => {
    const phoneCountryPrefix = phoneOptions?.code;
    if (phoneCountryPrefix) {
      const phone = new AsYouType(phoneCountryPrefix || 'BR');
      phone.input(phoneNumber);

      return isValidPhoneNumber(phone?.getNumber()?.number || '', phoneCountryPrefix);
    }

    return isPhone(phoneNumber);
  };

  if (!isFilled(values.name)) {
    errors.name = [t`fill in the name of the person in charge`];
  }

  if (!isFilled(values.email)) {
    errors.email = [t`fill in with your company email`];
  }

  if (isFilled(values.email) && !isEmail(values.email)) {
    errors.email = [t`fill a valid email`];
  }

  if (!isFilled(values.mobile_phone)) {
    errors.mobile_phone = [t`fill in the mobile number`];
  }

  if (isFilled(values.mobile_phone) && !validatePhone(values.mobile_phone || '')) {
    errors.mobile_phone = [t`invalid mobile phone number`];
  }

  if (!isFilled(values.cnpj)) {
    errors.cnpj = [t`type a valid cnpj`];
  }

  if (isFilled(values.cnpj) && !isCnpj(values.cnpj)) {
    errors.cnpj = [t`type a valid cnpj`];
  }

  if (!values.is_already_online_seller) {
    errors.is_already_online_seller = [t`select an option`];
  }

  return errors;
};

export default validatorForm;
